export default function ColorPicker(props) {
  const { input, disabled, wrapperClasses, className, label } = props

  return (
    <div className={`${disabled && 'disabled'} ${wrapperClasses}`}>
      {label && <label>{props.label}</label>}
      <div>
        <input {...input} className={className} type="color" {...input} />
      </div>
    </div>
  )
}